import { ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../interface/field.interface"
import { EipDatePickerComponent } from "../EIPDatePicker/eipdatepicker.component";
import { EipDateRangeComponent } from "../EIPDateRange/eipdaterange.component";
import { InputComponent } from "../input/input.component";
import { LabelComponent } from "../label/label.component";
import { SelectComponent } from "../select/select.component";

const componentMapper:any = {
    select: SelectComponent,
    input : InputComponent,
    eipdaterange : EipDateRangeComponent,
    eipdatepicker : EipDatePickerComponent,
    label : LabelComponent
};

@Directive({
    selector: '[dynamicField]'
})
export class DynamicFieldDirective implements OnInit {
    @Input() field!: FieldConfig;
    @Input() group!: FormGroup;
    @Input() formName:string = '';
    componentRef: any;
    constructor(private _resolver: ComponentFactoryResolver, private _container: ViewContainerRef) { }
    ngOnInit() {
        const factory = this._resolver.resolveComponentFactory(
            componentMapper[this.field.type]
        );
        this.componentRef = this._container.createComponent(factory);
        this.componentRef.instance.field = this.field;
        this.componentRef.instance.group = this.group;
        this.componentRef.instance.formName = this.formName;
    }
}